module.exports = __webpack_public_path__ + "img/Event-600x400.39199217.png";